<template>
  <div id="swiper-img" class="swiper-container">
    <div class="swiper-wrapper">
      <div v-for="(img,index) in imgs" id="banner" :key="index" class="swiper-slide" @click="pageTo(img.toPage)">
        <div :style="{backgroundImage:'url('+img.left+')'}" class="left" />
        <img :src="img.content" alt="轮播图banner" class="content">
        <div :style="{backgroundImage:'url('+img.right+')'}" class="right" />
      </div>
    </div>
    <!-- 如果需要分页器 -->
    <div class="swiper-pagination" />
    <!-- 如果需要滚动条 -->
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.min.css'
export default {
  props: {
    imgs: {
      type: Array,
      default: null
    }
  },
  data () {
    return {

    }
  },
  mounted () {
    this.initSwiper()
  },
  methods: {
    pageTo (address) {
      console.log('pageto')
      if (address === '') {
        return
      } else {
        window.location.href = address
      }
    },
    initSwiper () {
      const mySwiper = new Swiper('#swiper-img', {
        loop: true,
        autoplay: true,
        centeredSlides: true,
        autoplayDisableOnInteraction: true,
        delay: 5000,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        onSlideChangeEnd: function (swiper) {
          swiper.update()
          mySwiper.startAutoplay()
          mySwiper.reLoop()
        }
      })
      console.log(mySwiper)
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 0px) and (max-width: 1500px) {
.swiper-container {
  height: 580px;

}
#banner {

  display: flex;
  height: 100%;
  width: 100%;
}
#banner img {
  margin: 0 auto;

  height: 100%;
}
.left {
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  background-size: 360px 580px;
  background-position: 100% 100%;
  background-repeat: no-repeat;
}
.right {
  right: 0;
  height: 100%;
 width: 100%;
 background-size: 360px 580px;
  background-color: #ffffff;
  background-repeat: no-repeat;
}

}

@media only screen and (min-width: 1500px) and (max-width: 3000px) {
	.swiper-container {
  height: 100%;
  width: 100%;
}
#banner {
  display: flex;
  height: 100%;
  width: 100%;
}
#banner img {
  margin: 0 auto;
  height: 100%;
}
.left {
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  background-size: 360px 580px;
  background-position: 100% 100%;
  background-repeat: no-repeat;
}
.right {
  right: 0;
  height: 100%;
  background-size: 360px 580px;
  width: 100%;
  background-color: #ffffff;
  background-repeat: no-repeat;
}
}
</style>
